<app-header-translator></app-header-translator>
<app-product-spotlight
    [title]="'RENTER.HEADER_TITLE' | translate"
    [textContent]="'RENTER.HEADER_TEXT' | translate"
    [imageFilePath]="'/files/assets/img/renter-spotlight.jpg'">
</app-product-spotlight>
<app-general *ngIf="showGeneralPage" (gotoQuestionPageEvent)="goToQuestionPage($event)" [policytype] = "policytype"  #general></app-general>
<app-questions *ngIf="showQuestionPage" (gotoGeneralPageEvent)="goToGeneralPage($event)" [policytype] = "policytype" #questions></app-questions>
